import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';

const logoutPropertyTypes = {
  title: PropTypes.string,
  fillColor: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
  onClick: PropTypes.func,
  tabIndex: PropTypes.number,
  focusable: PropTypes.bool,
};

type LogoutProperties = PropTypes.InferProps<typeof logoutPropertyTypes> & {
  title?: string;
  fillColor?: string;
  width?: number;
  height?: number;
  className?: string;
  onClick?: () => void;
  tabIndex?: number;
  focusable?: boolean;
};

const Logout = ({
  title = 'Log out',
  fillColor = 'var(--grey-dark)',
  ...properties
}: LogoutProperties) => (
  <Icon
    // eslint-disable-next-line max-len
    dPath="M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
    title={title}
    fill={fillColor}
    {...properties}
  />
);

Logout.propTypes = logoutPropertyTypes;

export default Logout;
